<template>
    <div>
        <v-card>
          <v-card-title  style="background-color:#006699;color:white;">Visualização do comprovativo</v-card-title>
          <v-card-text >
            <v-row>
                <v-col md="12">
                 <img  :src="file"/>
                </v-col>
            </v-row>
            
          </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    name: 'listagem-comprovativo',
    props:['file']
}
</script>